import React, { useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";
import PAh2 from "../PAh2";
import PAtabs from "../PAtabs";
import { FormGroup, Select } from 'xsolla-uikit';

export default function PApsPayrank () {

  const [filter, setFilter] = useState('all')

    return (
      <div>

        <FormGroup indentation="lg">
          <div style={{display: 'flex', alignItems: 'center', }}>
            <PAh2 title="Payrank" indentation="xs"></PAh2>
            <CssH2Extra>
              <Select
                // disabled={this.disabled}
                align="right"
                name=""
                size="sm"
                options={[
                  { label: "Project 1", value: 1 },
                  { label: "Project 2", value: 2 }
                ]}
                // searchable={this.searchable}
                // autosize={this.autosize}
                // size={this.size}
                input={{
                  name: "widgTheme",
                  value: 1,
                  onChange: () => {
                    void 0;
                  }
                }}
              />
            </CssH2Extra>
          </div>
        </FormGroup>


        <div className="payrank-settings-container__tiles-container">
          <ul className="payrank-settings-container__payment-methods payrank-settings-container__payment-methods--two-sections">
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/235.1542275431.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Your Amazon Account"
              >
                Your Amazon Account
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/24.1545732900.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="PayPal"
              >
                PayPal
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/3431.1540892607.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Google Pay"
              >
                Google Pay
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/3376.1555591259.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="VanillaDirect"
              >
                VanillaDirect
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/3375.1555591231.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="GameStop"
              >
                GameStop
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/57.1553521238.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="paysafecard"
              >
                paysafecard
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/26.1548059943.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Visa / MasterCard"
              >
                Visa / MasterCard
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/1353.1515564926.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Subway Gift Card"
              >
                Subway Gift Card
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/3175.1532669069.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Apple Pay"
              >
                Apple Pay
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/2597.1529059566.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Visa Checkout"
              >
                Visa Checkout
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/465.1475061625.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Skrill Digital Wallet"
              >
                Skrill Digital Wallet
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/1417.1515565089.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Dollar General Card"
              >
                Dollar General Card
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/129.1467018904.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Rixty"
              >
                Rixty
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/1410.1515565268.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="CVS Gift Card"
              >
                CVS Gift Card
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/1776.1542698832.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="7Eleven"
              >
                7Eleven
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/3339.1555591116.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="CVS pharmacy"
              >
                CVS pharmacy
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/2870.1533208919.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Sprint"
              >
                Sprint
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/2931.1555589308.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Family Dollar"
              >
                Family Dollar
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/1999.1515565534.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="oBucks"
              >
                oBucks
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/2701.1532668233.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Masterpass"
              >
                Masterpass
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/3412.1555591396.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="Casey's General Stores"
              >
                Casey's General Stores
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/3484.1555591477.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="SkinsCash"
              >
                SkinsCash
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/2932.1555589322.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="ACE Cash Express"
              >
                ACE Cash Express
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/3023.1555589531.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="OfferPay "
              >
                OfferPay{" "}
              </div>
            </li>
            <li className="payrank-settings-container__payment-method">
              <div className="payrank-settings-container__payment-method__drag" />
              <div className="payrank-settings-container__payment-method__pin">
                <div className="xsui-checkbox xsui-checkbox--primary">
                  <div className="xsui-checkbox__wrapper">
                    <label data-value="false">
                      <input
                        className="xsui-checkbox__input"
                        type="checkbox"
                        defaultValue="false"
                      />
                      <div className="xsui-checkbox__label">1</div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="payrank-settings-container__payment-method__image"
                style={{
                  backgroundImage:
                    'url("//cdn.xsolla.net/paymentoptions/paystation/theme_33/108x63/3441.1540968937.png")'
                }}
              />
              <div
                className="payrank-settings-container__payment-method__name"
                title="MobileGo"
              >
                MobileGo
              </div>
            </li>
            <li className="payrank-settings-container__payment-methods__title payrank-settings-container__payment-methods__title--popular">
              Popular payment methods
            </li>
            <li className="payrank-settings-container__payment-methods__title payrank-settings-container__payment-methods__title--other">
              Other payment methods
            </li>
          </ul>
        </div>
      </div>
    );
  }



const CssH2Extra = styled.span`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
`
